// extracted by mini-css-extract-plugin
module.exports = {"filter":"list_filter_3cRwK"};